export function addUrlProtocol(value: string) {
	let newValue = value.trim().replace(/\s/g, '')

	const pattern = /^((http|https|ftp):\/\/)/

	const http = 'http://'
	const https = 'https://'

	if (!pattern.test(newValue) && !(http.startsWith(newValue) || https.startsWith(newValue))) {
		newValue = `https://${newValue}`
	}

	return newValue
}
